/**
 * The spec's "questionnaire ✕" rule: once the questionnaire has been submitted,
 * the vendor cannot ✕ the last live file of a question that would then owe one.
 * They replace it from the comment thread instead. The server enforces the same
 * rule on DELETE /me/submissions/:questionId/files/:fileId (`LAST_FILE_OWED`),
 * so this only hides a button the API would refuse.
 *
 * `owesFile` is questionOwesFileWithoutFiles(question, submission) from
 * @l2u/ui/lib/visibility.ts.
 */
export function lastOwedFileLocked(args: {
  submitted: boolean;
  liveFileCount: number;
  owesFile: boolean;
}): boolean {
  return args.submitted && args.liveFileCount <= 1 && args.owesFile;
}
